import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { ProductoCreateComponent } from '../../producto/producto-create/producto-create.component';
import { ProductoUpdateComponent } from '../../producto/producto-update/producto-update.component';
import { ProveedorCreateComponent } from '../proveedor-create/proveedor-create.component';
import { ProveedorUpdateComponent } from '../proveedor-update/proveedor-update.component';
import { ProveedorViewComponent } from '../proveedor-view/proveedor-view.component';
import { ProveedorService } from '../proveedor.service';

@Component({
  selector: 'app-proveedor-index',
  templateUrl: './proveedor-index.component.html',
  styleUrls: ['./proveedor-index.component.scss']
})
export class ProveedorIndexComponent implements OnInit {

  filtros = [
    {
      label: 'Nombre',
      column: 'nombre',
      op: 'substring'
    },
    {
      label: 'Apellido',
      column: 'apellido',
      op: 'substring'
    },
    {
      label: 'Razón Social',
      column: 'razon_social',
      op: 'substring'
    },
    {
      label: 'Correo Electrónico',
      column: 'email',
      op: 'substring'
    },
    {
      label: 'Estado',
      column: 'estado',
      op: 'eq',
      type: 'select',
      options: [
        {
          label: "Activo",
          value: 1
        },
        {
          label: "Inactivo",
          value: -1
        }
      ]
    }
  ]

  columnas: any[] = [
    {
      label: "Nombre",
      attribute: "nombre",
      value: (element: any) => {
        return this.formatter.nombreCompleto(element);
      }
    },
    {
      label: "Razón Social",
      attribute: "razon_social"
    },
    {
      label: "Correo Electrónico",
      attribute: "email"
    },
    {
      label: "Teléfono",
      attribute: "fono"
    }
    ,
    {
      label: "Estado",
      attribute: "estado",
      styled: true,
      value: (element: any) => {
        if (element.estado == 1) {
          return '<h5><span class="badge bg-primary">Activo</span></h5>';
        } else {
          return '<h5><span class="badge bg-secondary">Inactivo</span></h5>';
        }
      }
    }
  ]
  acciones: any[] = [

    {
      label: 'Detalle',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element.id);
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.update(element);
      }
    },
    {
      icon: "toggle-on",
      label: "Activar",
      action: (element: any) => {
        this.cambiarEstado(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == -1;
      }
    },
    {
      icon: "toggle-off",
      label: "Desactivar",
      action: (element: any) => {
        this.cambiarEstado(element);
      },
      hide: (element: any, index: number) => {
        return element.estado == 1;
      }
    }, {
      label: 'Eliminar',
      icon: 'trash',
      action: (element: any, index: number) => {
        this.delete(element);
      }
    }

  ]
  user = JSON.parse(localStorage.getItem('usuario') as string);
  reloadEmitter: EventEmitter<string> = new EventEmitter();
  constructor(
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    private modalService: NgbModal,
    public service: ProveedorService,
    public sesion: SesionService
  ) { }

  ngOnInit(): void { }

  agregar() {
    this.modalService.open(ProveedorCreateComponent, { size: 'lg', scrollable: true, backdrop: 'static' }).result.then((result: any) => {
      this.reloadEmitter.emit('true');
    }, (reason: any) => { });
  }

  view(id: number) {
    this.loading.show()
    this.service.view(id).subscribe((res: any) => {
      this.loading.hide();
      const modalRef = this.modalService.open(ProveedorViewComponent, { size: 'lg', scrollable: true });
      modalRef.componentInstance.element = res
      modalRef.result.then((result) => { }, (reason) => { });
    })

  }

  update(element: any) {
    this.loading.show()
    this.service.view(element.id).subscribe({
      next: (res) => {
        this.loading.hide();
        let modalRef = this.modalService.open(ProveedorUpdateComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
        modalRef.componentInstance.element = res;
        modalRef.result.then((result: any) => {
          this.reloadEmitter.emit('true');
        }, (reason: any) => { });
      }, error: (err) => {
        this.loading.hide();
        if (err.error) this.formatter.showErrorAlerts(err.error);
      }
    });

  }

  cambiarEstado(element: any) {
    this.loading.show()
    if (element.estado != 1) {
      this.service.activate(element).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro ", "danger");
        }
      })

    } else {
      this.service.deactivate(element).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro ", "danger");
        }
      });
    }
  }

  delete(element: any) {
    let modalRef = this.modalService.open(ModalDeleteComponent, { size: 'lg', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Proveedor';
    modalRef.componentInstance.texto = `¿Está seguro de que desea eliminar el proveedor "${element.nombre}"?`;
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result: any) => {
      this.loading.show()
      this.service.delete(element.id).subscribe({
        next: (res) => {
          this.loading.hide();
          this.reloadEmitter.emit('true');
          this.alerts.addAlert('El Proveedor se eliminó con éxito.', 'success');
        }, 
        error: err => {
          this.loading.hide();
          if (err.error) this.formatter.showErrorAlerts(err.error);
        }
      });
    }, (reason: any) => { });
  }
}
